module.exports = __webpack_public_path__ + "img/shanghuguanyu@2x.aa1525cd.png";